import { NgModule } from '@angular/core';
import { NbBadgeComponent } from './badge.component';

@NgModule({
  exports: [ NbBadgeComponent ],
  declarations: [ NbBadgeComponent ],
})
export class NbBadgeModule { }
